/* eslint-disable @typescript-eslint/no-explicit-any */
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowForwardIosRounded, Search } from "@material-ui/icons";
import CustomPopover from "components/UI/CustomPopover/CustomPopover";
import PopoverButton from "components/UI/CustomPopover/PopoverButton";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
// import GridItem from "components/UI/Grid/GridItem";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { sortDateWithDateFns } from "helpers/customSortMethods";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getBadgeFromStatus } from "utils/functions";
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const useStyles = makeStyles(styles as any);

type SowTableProps = {
  data: any;
  isLoading: boolean;
  isSowAdm: boolean;
  omit?: string[];
  initialPageSize?: number;
};

export default function SOWRelatedTable({
  data,
  isSowAdm,
  isLoading,
  omit = [],
  initialPageSize = 20,
}: SowTableProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation("sow-table");

  const columns = [
    {
      Header: t("status"),
      accessor: "status",
    },
    {
      Header: "ID",
      accessor: "sowID",
    },
    {
      Header: t("name"),
      accessor: "sowName",
    },
    {
      Header: t("supplier"),
      accessor: "supplierName",
    },
    {
      Header: t("start"),
      accessor: "startDate",
      sortType: sortDateWithDateFns,
      sortDescFirst: true,
    },
    {
      Header: t("end"),
      accessor: "endDate",
      sortType: sortDateWithDateFns,
      sortDescFirst: true,
    },
    {
      Header: t("actions"),
      accessor: "actions",
    },
  ];

  const columnsFiltered = columns.filter(
    (column) => !omit.includes(column.accessor),
  );

  const dataFormatted =
    data?.map((sow: { status: string; sowID: any }, index: number) => {
      return {
        ...sow,
        status: getBadgeFromStatus(sow?.status, (text: string) =>
          t(text, { ns: "status" }),
        ),
        actions: (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomPopover identifier={`sow-related-${index}`}>
              <PopoverButton
                onClick={() =>
                  isSowAdm
                    ? navigate(`/app/sows/profile?id=${sow?.sowID}`)
                    : navigate(`/app/sowsAdm/profile?id=${sow?.sowID}`)
                }
              >
                <ArrowForwardIosRounded style={{ fontSize: "1.2rem" }} />
                {t("Access SOW")}
              </PopoverButton>
            </CustomPopover>
          </div>
        ),
      };
    }) || [];

  return (
    <GridContainer>
      <GridItemTS key="sow-related-grid" xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Search />
            </CardIcon>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <h4 className={classes.cardIconTitle}>
                {t("Sows Related", { ns: "profile" })}
              </h4>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <ReactTable
                columns={columnsFiltered}
                data={dataFormatted}
                initialPageSize={initialPageSize}
                columnsNotTrimFilters={["sowName", "supplierName"]}
              />
            )}
          </CardBody>
        </Card>
      </GridItemTS>
    </GridContainer>
  );
}
